'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */

/**
 * Looks if the array contains passed item. If not, we append it to the end
 * of the array. If yes, we slice it out.
 *
 * @param {List} list
 * @param {any} item
 *
 * @returns {List} Mutated array.
 */
var arrayItemSliceOrAppend = exports.arrayItemSliceOrAppend = function arrayItemSliceOrAppend(list, item) {
  var index = list.indexOf(item);
  var result = index !== -1 ? list.delete(index) : list.push(item);
  return result;
};

/**
 * Used to search an array of objects for a match based on some condition.
 * The compare function runs on every item and checks if it satisfies the
 * condition. If yes, this method then returns the matched object or a
 * subset of the result based on the optional `key` argument.
 *
 * @param {List} list List of items to search.
 * @param {function} compareFunction Specifies a function that checks if this
 *   item is the one we are looking for.
 * @param {any} [key] Defines what the returned value will look like. If left
 *   undefined, we return the whole item. We can also pick a specific attribute
 *   from the object, or use a special keyword to return the object index.
 *
 * @returns {any} Based on the value of the `prop` parameter.
 */
var findInArray = exports.findInArray = function findInArray(list, compareFunction, key) {
  var reservedIndexKeyword = '$index';

  if (typeof compareFunction === 'function') {
    for (var i = 0; i < list.size; i += 1) {
      var item = list.get(i);
      var satisfiesCondition = compareFunction(item);
      if (satisfiesCondition) {
        if (key === reservedIndexKeyword) {
          return i;
        }
        if (key === null || key === undefined) {
          return item;
        }
        return item[key];
      }
    }
  }

  return key === reservedIndexKeyword ? -1 : false;
};

/**
 * Search for a match in array ignoring case sensitivity.
 *
 * @param {any} needle
 * @param {List} haystack
 *
 * @returns {integer} Matched index or -1 if not found.
 */
var includesCaseInsensitive = exports.includesCaseInsensitive = function includesCaseInsensitive(needle, haystack) {
  var needleUpper = needle.toUpperCase();
  for (var i = 0; i < haystack.size; i += 1) {
    var item = haystack.get(i).toUpperCase();
    if (item === needleUpper) return i;
  }
  return -1;
};